﻿import { Directive } from "@app/components/directive";
import { Dirs } from "@app/helpers/dirs";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgComponent({
    token: Token.KbPrivacyPolicy,
    dependencies: [
        Token.$Http
    ]
})
export class KbPrivacyPolicy extends Directive {
    constructor($http: ng.IHttpService) {
        super();

        this.restrict = "E";
        this.replace = true;
        this.scope = {
            _html: "="
        };
        this.template = Dirs.component("kb-privacy-policy");

        this.link = (scope:any, element, atts) => {
            /*$http.get("/privacy.html").then((d) => {
                scope._html = d.data;
            });*/
        };

    }
}
